import { assert_array_not_empty, assert_false, assert_true } from '@shared/asserts/utils_asserts';
import { ENUM__field_kind } from '../../_enums/ENUM__field_kind';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../DTO_GRAPH__instance';

declare module '../DTO_GRAPH__instance' {
  interface DTO_GRAPH__instance {
    grid2d__ensure_dimensions(): void;

    grid2d__get_first_field_available_for_dimension(): FIELD__base;

    //[row, column]
    grid2d__get_fields_dimensions(): [FIELD__base[], FIELD__base[]];

    //[row, column]
    grid2d__get_values(): [any[], any[]];
    /*
     * GRID2D COLUMN
     */
    grid2d__ensure_column(): void;

    grid2d__assign_first_available_as_column(): void;

    grid2d__get_field_column(): FIELD__base;

    grid2d__use_as_column(field_id: string): void;

    /*
     * GRID2D ROW
     */
    grid2d__ensure_row(): void;

    grid2d__assign_first_available_as_row(): void;

    grid2d__get_field_row(): FIELD__base;

    grid2d__use_as_row(field_id: string): void;

    /*
     *
     */

    grid2d__clear_existing_dimension(field: FIELD__base): void;

    grid2d__use_as_both_dimensions(field_id: string): void;

    grid2d__dimensions_swap(): void;

    grid2d__dimensions_reset_to_stub(): void;

    /*
     *
     */
    grid2d__apply_dimensions(field_row: FIELD__base, field_column: FIELD__base): void;

    //return tuple of related and unrelated nodes to grid2d dimensions
    grid2d__get_nodes_ids_related_and_unrelated(): [string[], string[]];
  }
}

export function INIT_EXTENSION_DTO_GRAPH__instance_grid2d() {
  // do nothing
}

/*
 * IMPLEMENTATION
 */

DTO_GRAPH__instance.prototype.grid2d__ensure_dimensions = function () {
  this.grid2d__ensure_row();
  this.grid2d__ensure_column();

  this.assert_grid2d_dimensions();
};

DTO_GRAPH__instance.prototype.grid2d__get_first_field_available_for_dimension = function () {
  let graph_dagre = this.dagre__convert_to();

  let nodes_ids_available = this.dagre__get_connected_ids(graph_dagre, this.invocation_grid2d_view.meta.node_id);

  nodes_ids_available.push(this.invocation_grid2d_view.meta.node_id);

  let fields_all: FIELD__base[] = [];

  for (let node_id of nodes_ids_available) {
    let node = this.node__get(node_id);

    let fields = node.fields__get_map(true).values();

    fields_all = [...fields_all, ...fields];
  }

  let out = [];

  for (let field of fields_all) {
    if (!field.meta.grid2d__can_be_dimension) continue;
    if (field.meta.grid2d__is_dimension) continue;
    if (field.meta.data__is_linked) continue;
    if (field.meta.field_kind != ENUM__field_kind.INPUT) continue;

    out.push(field);
  }

  assert_array_not_empty(out);

  return out[0];
};

DTO_GRAPH__instance.prototype.grid2d__get_fields_dimensions = function () {
  let [grid2d_rows, grid2d_columns]: FIELD__base[][] = [[], []];

  let fields_map = this.fields__get_map();

  for (const field of fields_map.values()) {
    if (field.meta.grid2d__is_row) grid2d_rows.push(field);
    if (field.meta.grid2d__is_column) grid2d_columns.push(field);
  }

  return [grid2d_rows, grid2d_columns];
};

//[row, column]
DTO_GRAPH__instance.prototype.grid2d__get_values = function () {
  let [field_grid2d_row, field_grid2d_column] = [this.grid2d__get_field_row(), this.grid2d__get_field_column()];

  let out: [any[], any[]] = [field_grid2d_row.grid2d_dimension_values, field_grid2d_column.grid2d_dimension_values];

  return out;
};

/*
 * GRID2D COLUMN
 */

DTO_GRAPH__instance.prototype.grid2d__ensure_column = function () {
  let field_column = this.grid2d__get_field_column();
  if (!field_column.is_stub()) return; //already assigned

  let node = this.invocation_grid2d_view;
  node.stub_grid2d_column.meta.grid2d__is_column = true; //assign to stub node
};

DTO_GRAPH__instance.prototype.grid2d__assign_first_available_as_column = function () {
  let target_field = this.grid2d__get_first_field_available_for_dimension();

  target_field.meta.grid2d__is_column = true;
};

DTO_GRAPH__instance.prototype.grid2d__get_field_column = function (): FIELD__base {
  let out = FIELD__base.CREATE_STUB();

  for (const field of this.fields__get_map().values()) {
    if (!field.meta.grid2d__is_column) continue;

    out = field;
    break;
  }

  return out;
};

DTO_GRAPH__instance.prototype.grid2d__use_as_column = function (field_id: string): void {
  let field = this.field__get_by_id(field_id);
  assert_false(field.meta.data__is_linked);

  if (field.meta.grid2d__is_column) return; //already used as column
  if (field.meta.grid2d__is_row) return this.grid2d__dimensions_swap(); //need just swap dimensions

  let field_grid2d_column_old = this.grid2d__get_field_column();
  this.grid2d__clear_existing_dimension(field_grid2d_column_old);

  field.meta.grid2d__is_column = true;

  this.field__replace(field);

  this.grid2d__ensure_dimensions(); //need ensure because we can reset other dimension. e.g: Token vs Token
};

/*
 * GRID2D ROW
 */

DTO_GRAPH__instance.prototype.grid2d__ensure_row = function () {
  let field_row = this.grid2d__get_field_row();
  if (!field_row.is_stub()) return; //already assigned

  let node = this.invocation_grid2d_view;
  node.stub_grid2d_row.meta.grid2d__is_row = true; //assign to stub node
};

DTO_GRAPH__instance.prototype.grid2d__assign_first_available_as_row = function () {
  let target_field = this.grid2d__get_first_field_available_for_dimension();

  target_field.meta.grid2d__is_row = true;
};

DTO_GRAPH__instance.prototype.grid2d__get_field_row = function (): FIELD__base {
  let out = FIELD__base.CREATE_STUB();

  let fields_map = this.fields__get_map();

  for (const field of fields_map.values()) {
    if (!field.meta.grid2d__is_row) continue;

    out = field;
    break;
  }

  return out;
};

DTO_GRAPH__instance.prototype.grid2d__use_as_row = function (field_id: string): void {
  let field = this.field__get_by_id(field_id);

  assert_false(field.meta.data__is_linked);
  if (field.meta.grid2d__is_row) return; //already used as row
  if (field.meta.grid2d__is_column) return this.grid2d__dimensions_swap(); //need just swap dimensions

  let field_grid2d_row_old = this.grid2d__get_field_row();
  this.grid2d__clear_existing_dimension(field_grid2d_row_old);

  field.meta.grid2d__is_row = true;
  this.field__replace(field);

  this.grid2d__ensure_dimensions(); //need ensure because we can reset other dimension. e.g: Token vs Token
};

/*
 *
 */

DTO_GRAPH__instance.prototype.grid2d__clear_existing_dimension = function (field: FIELD__base): void {
  if (field.is_stub()) return; //could be stub during first assignment

  assert_true(field.meta.grid2d__is_dimension);

  field = field.clone();
  [field.meta.grid2d__is_row, field.meta.grid2d__is_column] = [false, false];
  this.field__replace(field);
};

DTO_GRAPH__instance.prototype.grid2d__use_as_both_dimensions = function (field_id: string): void {
  let field = this.field__get_by_id(field_id);
  assert_false(field.meta.data__is_linked);

  if (field.meta.grid2d__is_column && field.meta.grid2d__is_row) return;

  let field_grid2d_column_old = this.grid2d__get_field_column();
  this.grid2d__clear_existing_dimension(field_grid2d_column_old);

  let field_grid2d_row_old = this.grid2d__get_field_row();
  this.grid2d__clear_existing_dimension(field_grid2d_row_old);

  [field.meta.grid2d__is_row, field.meta.grid2d__is_column] = [true, true];

  this.field__replace(field);
};

DTO_GRAPH__instance.prototype.grid2d__dimensions_swap = function (): void {
  let [field_grid2d_row, field_grid2d_column] = [this.grid2d__get_field_row(), this.grid2d__get_field_column()];

  assert_false(field_grid2d_row.meta.is_stub());
  assert_false(field_grid2d_column.meta.is_stub());

  field_grid2d_row = field_grid2d_row.clone();
  let meta_row = field_grid2d_row.meta;
  [meta_row.grid2d__is_row, meta_row.grid2d__is_column] = [false, true];

  field_grid2d_column = field_grid2d_column.clone();
  let meta_column = field_grid2d_column.meta;
  [meta_column.grid2d__is_row, meta_column.grid2d__is_column] = [true, false];

  this.field__replace(field_grid2d_row);
  this.field__replace(field_grid2d_column);
};

DTO_GRAPH__instance.prototype.grid2d__dimensions_reset_to_stub = function (): void {
  let { invocation_grid2d_view } = this;

  this.grid2d__use_as_row(invocation_grid2d_view.stub_grid2d_row.meta.field_id);
  this.grid2d__use_as_column(invocation_grid2d_view.stub_grid2d_column.meta.field_id);
};

/*
 *
 */

DTO_GRAPH__instance.prototype.grid2d__apply_dimensions = function (field_row: FIELD__base, field_column: FIELD__base): void {
  grid2d__apply_dimension_single(this, field_row);

  if (field_row.meta.field_id != field_column.meta.field_id) {
    grid2d__apply_dimension_single(this, field_column);
  }
};

function grid2d__apply_dimension_single(graph: DTO_GRAPH__instance, field_dimension: FIELD__base) {
  assert_false(field_dimension.meta.data__is_linked);

  field_dimension.grid2d_dimension__apply_for(graph);

  graph.field__replace(field_dimension);
}

DTO_GRAPH__instance.prototype.grid2d__get_nodes_ids_related_and_unrelated = function (): [string[], string[]] {
  let field_row = this.grid2d__get_field_row();
  let field_column = this.grid2d__get_field_column();

  let noted_ids_grid2d_related: string[] = [field_row.meta.node_id];

  let graph_dagre = this.dagre__convert_to();

  noted_ids_grid2d_related = [...noted_ids_grid2d_related, ...this.dagre__get_nodes_ids_from__all(graph_dagre, field_row.meta.node_id)];

  if (field_row.meta.node_id != field_column.meta.node_id) {
    noted_ids_grid2d_related = [
      field_column.meta.node_id,
      ...noted_ids_grid2d_related,
      ...this.dagre__get_nodes_ids_from__all(graph_dagre, field_column.meta.node_id),
    ];
  }

  /*
   *
   */
  let ids_to_rehash_set = new Set(noted_ids_grid2d_related);

  let nodes_ids_grid2d_unrelated = [];

  let nodes_ids_all = this.nodes__get_all().map(item => item.meta.node_id);

  for (let node_id of nodes_ids_all) {
    if (ids_to_rehash_set.has(node_id)) continue;

    nodes_ids_grid2d_unrelated.push(node_id);
  }

  return [noted_ids_grid2d_related, nodes_ids_grid2d_unrelated];
};
